import { useLingui } from "@lingui/react";
import { ElementType, Intent } from "@mobility-item-page/utilities/client";
import { Tab, TabPanel, Tabs } from "@warp-ds/react";
import usePulse from "src/utils/pulse-tracking/usePulse.ts";
import type { SafetyElementsProps } from "./Index.tsx";
import { useSafetyElements } from "./useSafetyElements.tsx";

const SafetyElementsDesktop = ({ safetyElements, memberAssociations }: SafetyElementsProps) => {
  const { i18n } = useLingui();

  const elements = useSafetyElements({ safetyElements, memberAssociations });
  const { trackClick } = usePulse();
  const safetyElementsAria = i18n._({
    id: "itemPageLayout.safetyElement.ariaLabel",
    message: "Safety elements",
  });

  const onClickTrackEvent = (trackingName: string, trackingId: string) => {
    // Tracking event: MO_ev42, MO_ev43, MO_ev44, MO_ev45, MO_ev46, MO_ev64, MO_ev62
    trackClick({
      name: trackingName,
      objectId: trackingId,
      elementType: ElementType.Tab,
      intent: Intent.Open,
    });
  };

  if (elements.length === 0) return null;
  return (
    <div className="mt-40 pt-40 border-t">
      <Tabs aria-label={safetyElementsAria} className="w-full [&>[role=tablist]]:flex">
        {elements.map((element, index) => (
          <Tab
            // the new icons have some space around them so we need to reduce the gap between icon and label
            className="gap-0 px-12"
            key={element.id}
            name={element.id}
            label={element.label}
            onClick={() => onClickTrackEvent(element.trackingName, element.trackingId)}
            over
            isActive={index === 0}
          >
            {element.icon}
          </Tab>
        ))}
      </Tabs>
      {elements.map((element, index) => (
        <TabPanel key={element.id} name={element.id} hidden={index !== 0}>
          {element.content}
        </TabPanel>
      ))}
    </div>
  );
};

export default SafetyElementsDesktop;
